<div class="cancel-container">
  <mat-card class="cancel-card">
    <mat-card-header>
      <mat-icon class="icon">cancel</mat-icon>
      <h2>Payment Cancelled</h2>
    </mat-card-header>
    <mat-card-content>
      <p>Your payment has been cancelled. If you need further assistance, please contact support.</p>
      <div  class="confirmation-details" style="font-family:monospace;">
        <p><strong>OrderID:</strong> {{ confirmationData?.orderId ||'-' }}</p>
        <p><strong>Amount :</strong> {{ confirmationData?.amount?('₹ '+confirmationData.amount):'-'}}</p>
        <p><strong>Status :</strong> {{ confirmationData?.status ||'-'}}</p>
      </div>
      <div class="timer-container">
        <p>Go Back in {{ countdown }} seconds</p>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-flat-button style="background-color: #721c24; color: white;" (click)="goBack()">Go Back</button>
    </mat-card-actions>
  </mat-card>
</div>
